var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7465_91950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49673 9.74997C7.81882 10.1806 8.22975 10.5369 8.70164 10.7947C9.17354 11.0525 9.69536 11.2058 10.2317 11.2442C10.7681 11.2826 11.3064 11.2053 11.8102 11.0173C12.3141 10.8294 12.7716 10.5353 13.1517 10.155L15.4017 7.90497C16.0848 7.19772 16.4628 6.25046 16.4543 5.26722C16.4457 4.28398 16.0513 3.34344 15.3561 2.64815C14.6608 1.95287 13.7202 1.55849 12.737 1.54995C11.7537 1.5414 10.8065 1.91938 10.0992 2.60247L8.80923 3.88497M10.4967 8.24997C10.1746 7.81938 9.76371 7.46309 9.29182 7.20527C8.81992 6.94745 8.2981 6.79414 7.76174 6.75572C7.22539 6.71731 6.68704 6.7947 6.18322 6.98264C5.6794 7.17058 5.2219 7.46467 4.84173 7.84497L2.59173 10.095C1.90864 10.8022 1.53066 11.7495 1.5392 12.7327C1.54775 13.716 1.94213 14.6565 2.63741 15.3518C3.33269 16.0471 4.27324 16.4415 5.25648 16.45C6.23972 16.4585 7.18697 16.0806 7.89423 15.3975L9.17673 14.115",
    stroke: "#45B184",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7465_91950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bd780a35f75cb56c6ec838a214d42a50.svg";
export { ForwardRef as ReactComponent };